import { render } from "./AppMenu.vue?vue&type=template&id=0fa74450&scoped=true"
import script from "./AppMenu.vue?vue&type=script&lang=js"
export * from "./AppMenu.vue?vue&type=script&lang=js"

import "./AppMenu.vue?vue&type=style&index=0&id=0fa74450&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa74450"],['__file',"src/components/app-structure/AppMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0fa74450"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0fa74450', __exports__)) {
    api.reload('0fa74450', __exports__)
  }
  
  module.hot.accept("./AppMenu.vue?vue&type=template&id=0fa74450&scoped=true", () => {
    api.rerender('0fa74450', render)
  })

}


export default __exports__